import { z } from "zod/v4";

/**
 * Local schema representations for alarm schedule metadata fields.
 * These are intentionally loose — the recorder stores whatever the caller
 * constructs. Strict validation lives in the alarm-schedules feature.
 */
const AlarmRoutineSchema = z.record(z.string(), z.unknown());
const AlarmResponseSchema = z.record(z.string(), z.unknown());
const AlarmExceptionSchema = z.record(z.string(), z.unknown());
const AlarmTimezoneSchema = z.string();
const AlarmOverrideSchema = z.record(z.string(), z.unknown());
const AlarmSilenceSchema = z.record(z.string(), z.unknown());
const AlarmContactsSchema = z.record(z.string(), z.unknown());

export const AlarmActivatedActivityMetadata = z.object({
  clipId: z.string(),
  thumbnailUrl: z.url().nullable(),
  capturedAt: z.iso.datetime(),
});
export type AlarmActivatedActivityMetadata = z.infer<typeof AlarmActivatedActivityMetadata>;

export const AlarmRoutineConfiguredActivityMetadata = z.object({
  routine: AlarmRoutineSchema.nullable(),
});
export type AlarmRoutineConfiguredActivityMetadata = z.infer<typeof AlarmRoutineConfiguredActivityMetadata>;

export const AlarmResponseConfiguredActivityMetadata = z.object({
  response: AlarmResponseSchema.nullable(),
});
export type AlarmResponseConfiguredActivityMetadata = z.infer<typeof AlarmResponseConfiguredActivityMetadata>;

export const AlarmExceptionConfiguredActivityMetadata = z.object({
  exceptions: z.array(AlarmExceptionSchema),
  exceptionsCount: z.number().int().nonnegative().nullable(),
});
export type AlarmExceptionConfiguredActivityMetadata = z.infer<typeof AlarmExceptionConfiguredActivityMetadata>;

export const AlarmTimezoneConfiguredActivityMetadata = z.object({
  timezone: AlarmTimezoneSchema.nullable(),
});
export type AlarmTimezoneConfiguredActivityMetadata = z.infer<typeof AlarmTimezoneConfiguredActivityMetadata>;

export const AlarmSilenceConfiguredActivityMetadata = z.object({
  silence: AlarmSilenceSchema.nullable(),
});
export type AlarmSilenceConfiguredActivityMetadata = z.infer<typeof AlarmSilenceConfiguredActivityMetadata>;

export const AlarmOverrideConfiguredActivityMetadata = z.object({
  override: AlarmOverrideSchema.nullable(),
});
export type AlarmOverrideConfiguredActivityMetadata = z.infer<typeof AlarmOverrideConfiguredActivityMetadata>;

export const AlarmContactsConfiguredActivityMetadata = z.object({
  contacts: AlarmContactsSchema,
});
export type AlarmContactsConfiguredActivityMetadata = z.infer<typeof AlarmContactsConfiguredActivityMetadata>;
